import { PiniaPluginContext } from 'pinia';
import { Plugin } from '@nuxt/types';
import { ref, set, useContext } from '@nuxtjs/composition-api';
import StoreConfigGql from '~/plugins/query/StoreConfig.gql';
import type { StoreConfig } from '~/modules/GraphQL/types';

const storeConfigPlugin: Plugin = async ({ $pinia, app }) => {
  const storeCode = app.$vsf.$magento.config.state.getStore();
  // const { data }: { data: { storeConfig?: StoreConfig } } = await app.$vsf.$magento.api.customQuery({ query: StoreConfigGql}, {store: storeCode? storeCode: 'zh'} );
  const { data }: { data: { storeConfig?: StoreConfig } } = await app.context.$vsf.$magento.api.customQuery({ 
    query: StoreConfigGql, 
    queryVariables: '',
    customHeaders: {
      'store': storeCode? storeCode: 'zh',
    }, 
  });

  $pinia.use(({ store }: PiniaPluginContext) => {
    if (store.$id !== 'magentoConfig') return;
    const storeConfig = ref(data?.storeConfig ?? {});

    if (!store.$state?.storeConfig) {
      set(store.$state, 'storeConfig', storeConfig);
    } else {
      store.$state.storeConfig = storeConfig;
    }
  });
};

export default storeConfigPlugin;
